export default "__VITE_ASSET__BJ0MYwbh__"